export default __webpack_public_path__ + "static/media/mutual-ic-star-filled.24f1052a.svg";